import { createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives, withCtx as _withCtx, vModelText as _vModelText, vModelCheckbox as _vModelCheckbox, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createSlots as _createSlots } from "vue"

const _hoisted_1 = {
  id: "Central__Calendar",
  class: "page-layout"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "mt-2 rounded task-manager-header" }, "Employee Task Manager", -1 /* HOISTED */)
const _hoisted_3 = {
  class: "card px-0 h-100",
  id: "App__Calendar"
}
const _hoisted_4 = { class: "d-flex flex-wrap flex-xl-nowrap w-100" }
const _hoisted_5 = { class: "d-flex flex-wrap align-items-center flex-lg-nowrap p-0 m-0 w-100" }
const _hoisted_6 = { class: "form-group me-2 mb-2 flex-shrink-1" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("label", { for: "agency-location-id" }, " Branch ", -1 /* HOISTED */)
const _hoisted_8 = {
  key: 0,
  value: null
}
const _hoisted_9 = ["value"]
const _hoisted_10 = { class: "form-group me-2 mb-2" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("label", { for: "client-list" }, " Client ", -1 /* HOISTED */)
const _hoisted_12 = { class: "form-group me-2 mb-2 flex-shrink-1" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("label", { for: "dateFrom" }, "Date From:", -1 /* HOISTED */)
const _hoisted_14 = { class: "input-group date datepickerInput" }
const _hoisted_15 = ["value"]
const _hoisted_16 = /*#__PURE__*/_createElementVNode("div", { class: "input-group-addon input-group-append" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "input-group-text" }, [
    /*#__PURE__*/_createElementVNode("i", { class: "fa fa-calendar" })
  ])
], -1 /* HOISTED */)
const _hoisted_17 = { class: "form-group me-2 mb-2 flex-shrink-1" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("label", { for: "dateTo" }, "Date To:", -1 /* HOISTED */)
const _hoisted_19 = { class: "input-group date datepickerInput" }
const _hoisted_20 = ["value"]
const _hoisted_21 = /*#__PURE__*/_createElementVNode("div", { class: "input-group-addon input-group-append" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "input-group-text" }, [
    /*#__PURE__*/_createElementVNode("i", { class: "fa fa-calendar" })
  ])
], -1 /* HOISTED */)
const _hoisted_22 = { class: "form-group mb-2" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("label", { for: "date-to" }, "Filter by text:", -1 /* HOISTED */)
const _hoisted_24 = { class: "input-group" }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("span", { class: "input-group-append" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "input-group-text bg-transparent p-2" }, [
    /*#__PURE__*/_createElementVNode("i", { class: "fas fa-search font-size-sm" })
  ])
], -1 /* HOISTED */)
const _hoisted_26 = { class: "col-auto ms-auto me-0 p-0 mt-auto mb-auto" }
const _hoisted_27 = ["disabled"]
const _hoisted_28 = { class: "table-scroll-wrapper" }
const _hoisted_29 = { class: "table table-responsive-md border border-gray" }
const _hoisted_30 = { key: 0 }
const _hoisted_31 = { class: "bg-table-header" }
const _hoisted_32 = { class: "form-check custom-checkbox form-check-inline ms-1 me-0" }
const _hoisted_33 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label highlight",
  for: "task-select-all"
}, [
  /*#__PURE__*/_createElementVNode("span")
], -1 /* HOISTED */)
const _hoisted_34 = /*#__PURE__*/_createElementVNode("th", null, "Task Document", -1 /* HOISTED */)
const _hoisted_35 = /*#__PURE__*/_createElementVNode("th", null, "Date", -1 /* HOISTED */)
const _hoisted_36 = /*#__PURE__*/_createElementVNode("th", null, "Time", -1 /* HOISTED */)
const _hoisted_37 = /*#__PURE__*/_createElementVNode("th", null, "Status", -1 /* HOISTED */)
const _hoisted_38 = /*#__PURE__*/_createElementVNode("th", null, "Patient", -1 /* HOISTED */)
const _hoisted_39 = /*#__PURE__*/_createElementVNode("th", null, "Branch", -1 /* HOISTED */)
const _hoisted_40 = { key: 1 }
const _hoisted_41 = { class: "bg-table-header" }
const _hoisted_42 = { class: "form-check custom-checkbox form-check-inline ms-1 me-0" }
const _hoisted_43 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label highlight",
  for: "task-select-all"
}, [
  /*#__PURE__*/_createElementVNode("span")
], -1 /* HOISTED */)
const _hoisted_44 = /*#__PURE__*/_createTextVNode("Task Document ")
const _hoisted_45 = /*#__PURE__*/_createTextVNode(" Date ")
const _hoisted_46 = /*#__PURE__*/_createTextVNode(" Time ")
const _hoisted_47 = /*#__PURE__*/_createTextVNode(" Status ")
const _hoisted_48 = /*#__PURE__*/_createTextVNode(" Patient ")
const _hoisted_49 = /*#__PURE__*/_createTextVNode(" Branch ")
const _hoisted_50 = {
  key: 0,
  class: "table-empty"
}
const _hoisted_51 = ["colspan"]
const _hoisted_52 = /*#__PURE__*/_createElementVNode("h3", null, "No Tasks Found.", -1 /* HOISTED */)
const _hoisted_53 = [
  _hoisted_52
]
const _hoisted_54 = {
  key: 1,
  class: "table-error"
}
const _hoisted_55 = ["colspan"]
const _hoisted_56 = /*#__PURE__*/_createElementVNode("span", { class: "shimmer-loading" }, null, -1 /* HOISTED */)
const _hoisted_57 = [
  _hoisted_56
]
const _hoisted_58 = { key: 2 }
const _hoisted_59 = {
  key: 0,
  class: "form-check custom-checkbox form-check-inline ms-1 zindex-0"
}
const _hoisted_60 = ["id", "value"]
const _hoisted_61 = ["for"]
const _hoisted_62 = /*#__PURE__*/_createElementVNode("span", null, null, -1 /* HOISTED */)
const _hoisted_63 = [
  _hoisted_62
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_EmployeeBulkReassign = _resolveComponent("EmployeeBulkReassign")!
  const _component_MultiSelectFilter = _resolveComponent("MultiSelectFilter")!
  const _component_DatePicker = _resolveComponent("DatePicker")!
  const _component_SortableTh = _resolveComponent("SortableTh")!
  const _component_ErrorMessageHandler = _resolveComponent("ErrorMessageHandler")!
  const _component_EmptyTextHandler = _resolveComponent("EmptyTextHandler")!
  const _component_ListLayout = _resolveComponent("ListLayout")!

  return (_openBlock(), _createElementBlock("main", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("main", _hoisted_3, [
      _createVNode(_component_ListLayout, {
        "has-title": _ctx.hideTitle,
        "page-title": _ctx.employeeName,
        "form-title": "Bulk Reassign",
        "show-form": _ctx.isAddItemRequested
      }, _createSlots({
        "list-header": _withCtx(() => [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _hoisted_7,
                _withDirectives(_createElementVNode("select", {
                  id: "Referral_Agency_Branch",
                  name: "agency-location-id",
                  class: "form-select",
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.branchId) = $event)),
                  onChange: _cache[1] || (_cache[1] = ($event: any) => (_ctx.branchUpdated(_ctx.branchId)))
                }, [
                  (_ctx.branchList.length != 1)
                    ? (_openBlock(), _createElementBlock("option", _hoisted_8, "All"))
                    : _createCommentVNode("v-if", true),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.branchList, (branch) => {
                    return (_openBlock(), _createElementBlock("option", {
                      value: branch.id,
                      key: branch.id
                    }, _toDisplayString(branch.name), 9 /* TEXT, PROPS */, _hoisted_9))
                  }), 128 /* KEYED_FRAGMENT */))
                ], 544 /* HYDRATE_EVENTS, NEED_PATCH */), [
                  [_vModelSelect, _ctx.branchId]
                ])
              ]),
              _createElementVNode("div", _hoisted_10, [
                _hoisted_11,
                _createVNode(_component_MultiSelectFilter, {
                  id: "client-list",
                  "on-fetch": _ctx.userCredentialsFetch,
                  "selected-items": _ctx.selectedClients,
                  onSelectedItemsUpdated: _ctx.selectedItemsUpdated,
                  name: "Clients"
                }, null, 8 /* PROPS */, ["on-fetch", "selected-items", "onSelectedItemsUpdated"])
              ]),
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("div", null, [
                  _hoisted_13,
                  _createVNode(_component_DatePicker, { getDate: _ctx.changeDate }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_14, [
                        _createElementVNode("input", {
                          type: "text",
                          class: "form-control",
                          name: "dateFrom",
                          value: _ctx.formatDateInput(_ctx.dateFrom),
                          onChange: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.handleDateInputChange && _ctx.handleDateInputChange(...args)))
                        }, null, 40 /* PROPS, HYDRATE_EVENTS */, _hoisted_15),
                        _hoisted_16
                      ])
                    ]),
                    _: 1 /* STABLE */
                  }, 8 /* PROPS */, ["getDate"])
                ])
              ]),
              _createElementVNode("div", _hoisted_17, [
                _createElementVNode("div", null, [
                  _hoisted_18,
                  _createVNode(_component_DatePicker, { getDate: _ctx.changeDate }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_19, [
                        _createElementVNode("input", {
                          type: "text",
                          class: "form-control",
                          name: "dateTo",
                          value: _ctx.formatDateInput(_ctx.dateTo),
                          onChange: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.handleDateInputChange && _ctx.handleDateInputChange(...args)))
                        }, null, 40 /* PROPS, HYDRATE_EVENTS */, _hoisted_20),
                        _hoisted_21
                      ])
                    ]),
                    _: 1 /* STABLE */
                  }, 8 /* PROPS */, ["getDate"])
                ])
              ]),
              _createElementVNode("div", _hoisted_22, [
                _createElementVNode("div", null, [
                  _hoisted_23,
                  _createElementVNode("div", _hoisted_24, [
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      class: "form-control border-end-0",
                      placeholder: "Start Typing",
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.term) = $event))
                    }, null, 512 /* NEED_PATCH */), [
                      [_vModelText, _ctx.term]
                    ]),
                    _hoisted_25
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_26, [
              _createElementVNode("button", {
                type: "button",
                disabled: _ctx.selectedTaskId.length === 0,
                class: "btn btn-sm btn-primary ms-2",
                onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.openReassignForm()))
              }, " Reassign ", 8 /* PROPS */, _hoisted_27),
              _createElementVNode("button", {
                type: "button",
                class: "btn btn-sm btn-outline-primary ms-2",
                onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.redirectToEmployeeList()))
              }, " View Calendar ")
            ])
          ])
        ]),
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_28, [
            _createElementVNode("table", _hoisted_29, [
              (!_ctx.hasData)
                ? (_openBlock(), _createElementBlock("thead", _hoisted_30, [
                    _createElementVNode("tr", _hoisted_31, [
                      _createElementVNode("th", null, [
                        _createElementVNode("div", _hoisted_32, [
                          _withDirectives(_createElementVNode("input", {
                            type: "checkbox",
                            class: "form-check-input",
                            id: "task-select-all",
                            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.selectAll) = $event)),
                            onChange: _cache[8] || (_cache[8] = ($event: any) => (_ctx.changeAllSelection()))
                          }, null, 544 /* HYDRATE_EVENTS, NEED_PATCH */), [
                            [_vModelCheckbox, _ctx.selectAll]
                          ]),
                          _hoisted_33
                        ])
                      ]),
                      _hoisted_34,
                      _hoisted_35,
                      _hoisted_36,
                      _hoisted_37,
                      _hoisted_38,
                      _hoisted_39
                    ])
                  ]))
                : (_openBlock(), _createElementBlock("thead", _hoisted_40, [
                    _createElementVNode("tr", _hoisted_41, [
                      _createElementVNode("th", null, [
                        _createElementVNode("div", _hoisted_42, [
                          _withDirectives(_createElementVNode("input", {
                            type: "checkbox",
                            class: "form-check-input",
                            id: "task-select-all",
                            "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.selectAll) = $event)),
                            onChange: _cache[10] || (_cache[10] = ($event: any) => (_ctx.changeAllSelection()))
                          }, null, 544 /* HYDRATE_EVENTS, NEED_PATCH */), [
                            [_vModelCheckbox, _ctx.selectAll]
                          ]),
                          _hoisted_43
                        ])
                      ]),
                      _createElementVNode("th", null, [
                        _createVNode(_component_SortableTh, {
                          "sort-by": _ctx.sortBy,
                          onSortByUpdated: _ctx.sortByUpdated,
                          "sort-order": _ctx.sortOrder,
                          onSortOrderUpdated: _ctx.sortOrderUpdated,
                          "sort-string": "TaskName"
                        }, {
                          default: _withCtx(() => [
                            _hoisted_44
                          ]),
                          _: 1 /* STABLE */
                        }, 8 /* PROPS */, ["sort-by", "onSortByUpdated", "sort-order", "onSortOrderUpdated"])
                      ]),
                      _createElementVNode("th", null, [
                        _createVNode(_component_SortableTh, {
                          "sort-by": _ctx.sortBy,
                          onSortByUpdated: _ctx.sortByUpdated,
                          "sort-order": _ctx.sortOrder,
                          onSortOrderUpdated: _ctx.sortOrderUpdated,
                          "sort-string": "StartDate"
                        }, {
                          default: _withCtx(() => [
                            _hoisted_45
                          ]),
                          _: 1 /* STABLE */
                        }, 8 /* PROPS */, ["sort-by", "onSortByUpdated", "sort-order", "onSortOrderUpdated"])
                      ]),
                      _createElementVNode("th", null, [
                        _createVNode(_component_SortableTh, {
                          "sort-by": _ctx.sortBy,
                          onSortByUpdated: _ctx.sortByUpdated,
                          "sort-order": _ctx.sortOrder,
                          onSortOrderUpdated: _ctx.sortOrderUpdated,
                          "sort-string": "StartTime"
                        }, {
                          default: _withCtx(() => [
                            _hoisted_46
                          ]),
                          _: 1 /* STABLE */
                        }, 8 /* PROPS */, ["sort-by", "onSortByUpdated", "sort-order", "onSortOrderUpdated"])
                      ]),
                      _createElementVNode("th", null, [
                        _createVNode(_component_SortableTh, {
                          "sort-by": _ctx.sortBy,
                          onSortByUpdated: _ctx.sortByUpdated,
                          "sort-order": _ctx.sortOrder,
                          onSortOrderUpdated: _ctx.sortOrderUpdated,
                          "sort-string": "Status"
                        }, {
                          default: _withCtx(() => [
                            _hoisted_47
                          ]),
                          _: 1 /* STABLE */
                        }, 8 /* PROPS */, ["sort-by", "onSortByUpdated", "sort-order", "onSortOrderUpdated"])
                      ]),
                      _createElementVNode("th", null, [
                        _createVNode(_component_SortableTh, {
                          "sort-by": _ctx.sortBy,
                          onSortByUpdated: _ctx.sortByUpdated,
                          "sort-order": _ctx.sortOrder,
                          onSortOrderUpdated: _ctx.sortOrderUpdated,
                          "sort-string": "PatientFirstName"
                        }, {
                          default: _withCtx(() => [
                            _hoisted_48
                          ]),
                          _: 1 /* STABLE */
                        }, 8 /* PROPS */, ["sort-by", "onSortByUpdated", "sort-order", "onSortOrderUpdated"])
                      ]),
                      _createElementVNode("th", null, [
                        _createVNode(_component_SortableTh, {
                          "sort-by": _ctx.sortBy,
                          onSortByUpdated: _ctx.sortByUpdated,
                          "sort-order": _ctx.sortOrder,
                          onSortOrderUpdated: _ctx.sortOrderUpdated,
                          "sort-string": "BranchName"
                        }, {
                          default: _withCtx(() => [
                            _hoisted_49
                          ]),
                          _: 1 /* STABLE */
                        }, 8 /* PROPS */, ["sort-by", "onSortByUpdated", "sort-order", "onSortOrderUpdated"])
                      ])
                    ])
                  ])),
              _createElementVNode("tbody", null, [
                _createCommentVNode(" EMPTY "),
                (!_ctx.isLoading && !_ctx.isError && !_ctx.hasData)
                  ? (_openBlock(), _createElementBlock("tr", _hoisted_50, [
                      _createElementVNode("td", { colspan: _ctx.columns }, _hoisted_53, 8 /* PROPS */, _hoisted_51)
                    ]))
                  : _createCommentVNode("v-if", true),
                _createCommentVNode(" ERROR "),
                (!_ctx.isLoading && _ctx.isError)
                  ? (_openBlock(), _createElementBlock("tr", _hoisted_54, [
                      _createElementVNode("td", { colspan: _ctx.columns }, [
                        _createVNode(_component_ErrorMessageHandler, {
                          title: "Inquiry list",
                          onTryAgain: _cache[11] || (_cache[11] = ($event: any) => (_ctx.pageReset()))
                        })
                      ], 8 /* PROPS */, _hoisted_55)
                    ]))
                  : _createCommentVNode("v-if", true),
                _createCommentVNode(" LOADING "),
                (_ctx.isLoading)
                  ? (_openBlock(true), _createElementBlock(_Fragment, { key: 2 }, _renderList(_ctx.loadingCount, (i) => {
                      return (_openBlock(), _createElementBlock("tr", {
                        class: "table-loading",
                        key: i
                      }, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.columns, (i) => {
                          return (_openBlock(), _createElementBlock("td", { key: i }, _hoisted_57))
                        }), 128 /* KEYED_FRAGMENT */))
                      ]))
                    }), 128 /* KEYED_FRAGMENT */))
                  : _createCommentVNode("v-if", true)
              ]),
              _createCommentVNode(" LIST "),
              (!_ctx.isLoading && !_ctx.isError && _ctx.hasData)
                ? (_openBlock(), _createElementBlock("tbody", _hoisted_58, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredTasks, (task) => {
                      return (_openBlock(), _createElementBlock("tr", {
                        key: task.Id,
                        class: _normalizeClass(`${_ctx.selectedTaskId.includes(task.Id) ? 'select-row' : ''}`)
                      }, [
                        _createElementVNode("td", null, [
                          (!_ctx.isReadOnlyTask(task))
                            ? (_openBlock(), _createElementBlock("div", _hoisted_59, [
                                _withDirectives(_createElementVNode("input", {
                                  type: "checkbox",
                                  class: "form-check-input",
                                  id: `task_${task.Id}`,
                                  value: task.Id,
                                  "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.selectedTaskId) = $event)),
                                  onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.taskChanged($event)))
                                }, null, 8 /* PROPS */, _hoisted_60), [
                                  [_vModelCheckbox, _ctx.selectedTaskId]
                                ]),
                                _createElementVNode("label", {
                                  class: "form-check-label",
                                  for: `task_${task.Id}`
                                }, _hoisted_63, 8 /* PROPS */, _hoisted_61)
                              ]))
                            : _createCommentVNode("v-if", true)
                        ]),
                        _createElementVNode("td", null, _toDisplayString(task.TaskName), 1 /* TEXT */),
                        _createElementVNode("td", null, _toDisplayString(_ctx.formatDate(task.StartDate, "MM/DD/YY")), 1 /* TEXT */),
                        _createElementVNode("td", null, _toDisplayString(_ctx.getVisitTime(task)), 1 /* TEXT */),
                        _createElementVNode("td", null, [
                          _createVNode(_component_EmptyTextHandler, {
                            text: task.Status
                          }, null, 8 /* PROPS */, ["text"])
                        ]),
                        _createElementVNode("td", null, _toDisplayString(_ctx.getFullName(task)), 1 /* TEXT */),
                        _createElementVNode("td", null, _toDisplayString(task.BranchName), 1 /* TEXT */)
                      ], 2 /* CLASS */))
                    }), 128 /* KEYED_FRAGMENT */))
                  ]))
                : _createCommentVNode("v-if", true)
            ])
          ])
        ]),
        _: 2 /* DYNAMIC */
      }, [
        (_ctx.selectedTaskId.length)
          ? {
              name: "list-form",
              fn: _withCtx(() => [
                _createCommentVNode(" continue from here "),
                _createVNode(_component_EmployeeBulkReassign, {
                  application: _ctx.application,
                  "agency-id": _ctx.agencyId,
                  "user-id": _ctx.userId,
                  "selected-task-id": _ctx.selectedTaskId,
                  "close-reassign-form": _ctx.closeReassignForm,
                  "page-reset": _ctx.pageReset,
                  "date-from": _ctx.dateFrom,
                  "date-to": _ctx.dateTo,
                  "branch-id": _ctx.branchIds
                }, null, 8 /* PROPS */, ["application", "agency-id", "user-id", "selected-task-id", "close-reassign-form", "page-reset", "date-from", "date-to", "branch-id"])
              ])
            }
          : undefined
      ]), 1032 /* PROPS, DYNAMIC_SLOTS */, ["has-title", "page-title", "show-form"])
    ])
  ]))
}